/**
 * @param {string} selector
 * @returns {boolean}
 */
export function isValidQuerySelector(selector) {
  if (typeof selector !== 'string') return false;
  try {
    document.querySelector(selector);
  } catch (error) {
    return false;
  }
  return true;
}

// let invalidSelectorPattern = /[^a-zA-Z0-9_\-#]/;
// let invalidSelector = selector.match(invalidSelectorPattern);
